module.exports = __webpack_public_path__ + "static/img/function2.eae20c23.png";